<template>
  <div class="examsubjectBox">
    <transition-group class="examsubjectInfoBox" name="list-complete" tag="div">
      <div
        :key="'addBut'"
        @click="operInfo(1)"
        class="subjectAddButBox"
      >
        <i class="el-icon-plus"></i>
        <p>添加考试科目</p>
      </div>
      <SubjectInfo
        v-for="item in tableList"
        :key="item.subjectId"
        :rowInfo="item"
        @removeInfo="removeInfo"
        @operInfo="operInfo"
      />
    </transition-group>
    <el-dialog
      custom-class="dailogComponents"
      :title="visibleType == 1 ? '添加' : '修改'"
      :visible.sync="visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      v-if="visible"
      width="540px"
    >
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="10">
            <p><span style="color:red;">*</span>科目名称:</p>
          </el-col>
          <el-col :span="20">
            <el-input
              v-model="visibleObj.subjectName"
              :disabled="visibleObj.changeAll!=0"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
          <el-col :span="10">
            <p><span style="color:red;">*</span>英文名称:</p>
          </el-col>
          <el-col style="padding-right:5px">
            <el-input
              v-model="visibleObj.subjectYwname"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-row>
        <div class="dailogTbaleBox">
          <table class="bgTable">
            <tr>
              <td class="bg">报考级别</td>
              <td class="bg">考级费用（元）</td>
              <td class="bg">是否需要审核</td>
              <td style="width:40px" class="bg">操作</td>
            </tr>
            <tr
              v-for="(item, index) in visibleObj.subjectLevelDTOs"
              :key="index"
            >
              <td>
                <el-select
                  v-model="item.subjectLevel"
                  :disabled="visibleObj.changeAll!=0"
                  @change="lvSelectChange(item)"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="lvObj in lvListForCh"
                    :key="lvObj.id"
                    :value="lvObj.id"
                    :label="lvObj.lv"
                  ></el-option>
                </el-select>
              </td>
              <td>
                <el-input-number
                  controls-position="right"
                  style="width:100%;"
                  :disabled="visibleObj.change!=0"
                  v-model="item.subjectAmount"
                  :min="0"
                ></el-input-number>
              </td>
              <td>
                <el-radio-group :disabled="visibleObj.change!=0" v-model="item.needVerify">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </td>
              <td>
                <template v-if="visibleObj.changeAll==0">
                    <i
                      v-if="index + 1 == visibleObj.subjectLevelDTOs.length"
                      @click="operatLvList(1, item)"
                      class="butIconAdd el-icon-circle-plus"
                    ></i>
                    <i
                      v-else
                      @click="operatLvList(0, index)"
                      class="butIconRemove el-icon-remove"
                    ></i>
                </template>
              </td>

            </tr>
          </table>
        </div>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-button size="medium" @click="visible = false">取消</el-button>
          <Debounce>
            <el-button size="medium" type="primary" @click="submit"
              >确认</el-button
            >
          </Debounce>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SubjectInfo from "./subjectInfo";
export default {
  components: {
    SubjectInfo,
  },
  data() {
    return {
      tableList: [],
      visible: false,
      visibleType: 1,
      visibleObj: {
        subjectName: "",
        subjectYwname: "",
        subjectLevelDTOs: [
          { needVerify: true, subjectAmount: 0, subjectLevel: "" },
        ],
      },
      lvListForCh: [
        { id: "", lv: "请选择" },
        { id: 1, lv: "一级" },
        { id: 2, lv: "二级" },
        { id: 3, lv: "三级" },
        { id: 4, lv: "四级" },
        { id: 5, lv: "五级" },
        { id: 6, lv: "六级" },
        { id: 7, lv: "七级" },
        { id: 8, lv: "八级" },
        { id: 9, lv: "九级" },
        { id: 10, lv: "十级" },
        { id: 11, lv: "初级" },
        { id: 12, lv: "中级" },
        { id: 13, lv: "高级" },
      ],
      lvAmoutList: [0, 200, 230, 260, 290, 320, 350, 380, 410, 440, 470],
    };
  },
  computed: {
    unSelectLv() {
      let selectList = this.lvListForCh.filter((lvObj) => {
        let selectObj = this.visibleObj.subjectLevelDTOs.find((item) => {
          if (lvObj.id == item.subjectLevel) {
            return item;
          }
        });
        if (!selectObj) {
          return lvObj;
        }
      });
      return selectList;
    },
  },
  methods: {
    tableLoad() {
      this.$axios.get("/subject").then((res) => {
        this.tableList = res.data.data.list;
      });
    },
    removeInfo(id) {
      this.$axios.delete("/subject?subjectId=" + id).then((res) => {
        this.$message({ type: "success", message: "操作成功!" ,duration:1000});
        this.tableLoad();
      });
    },
    operInfo(type, rowInfo) {
      this.visible = true;
      this.visibleType = type;
      this.visibleObj = {
        subjectName: "",
        change:0,
        changeAll:0,
        subjectLevelDTOs: [
          { needVerify: true, subjectAmount: 0, subjectLevel: "" },
        ],
      };
      if (type === 1) {
        //添加
      } else if (type === 2) {
        //修改
        this.visibleObj = JSON.parse(JSON.stringify(rowInfo));
      }
    },
    submit() {
      let { subjectName, subjectLevelDTOs } = this.visibleObj;
      let isSub = true,
        IDList = [];
      subjectLevelDTOs.filter((item) => {
        IDList.push(item.subjectLevel);
        if (item.subjectLevel == "") {
          isSub = false;
          return;
        }
      });
      if (!isSub || subjectName == "") {
        this.$message({ type: "warning", message: "请填写全部数据!" ,duration:1000});
        return;
      }
      if (new Set(IDList).size != IDList.length) {
        this.$message({
          type: "warning",
          message: "单个报考级别只能提交一种!",duration:1000
        });
        return;
      }
      let subType = this.visibleType === 1 ? "post" : "put";
      this.$axios({
        method: subType,
        url: "/subject",
        data: this.visibleObj,
      }).then((res) => {
        this.$message({ type: "success", message: "保存成功!",duration:600 });
        this.visible = false;
        this.tableLoad();
      });
    },
    operatLvList(type, item) {
      if (type == 0) {
        //删除
        this.visibleObj.subjectLevelDTOs.splice(item, 1);
      } else {
        //添加
        if (this.visibleObj.subjectLevelDTOs.length == 10) {
          this.$message.warning("已经到最大值,无法继续添加!");
          return;
        }
        this.visibleObj.subjectLevelDTOs.push({
          needVerify: true,
          subjectAmount: 0,
          subjectLevel: "",
        });
      }
    },
    lvSelectChange(item) {
      item.subjectAmount = this.lvAmoutList[item.subjectLevel || 0];
    },
  },
  mounted() {
    this.tableLoad();
  },
};
</script>

<style lang="scss" scoped>
.examsubjectBox {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .dialogBox {
    padding: 10px;
    .dailogTbaleBox{
      max-height: 360px;
      overflow-y: auto;
      margin-bottom: 10px;
    }
    .dialogTitle {
      p {
        line-height: 260%;
        text-align: right;
      }
      .el-input {
        margin-left: 5px;
      }
    }
    .bgTable {
      .butIconRemove,
      .butIconAdd {
        cursor: pointer;
        font-size: 18px;
      }
      .butIconRemove {
        color: #f56c6c;
      }
      .butIconAdd {
        color: #409eff;
      }
    }
  }
}
.examsubjectInfoBox {
  display: flex;
  flex-wrap: wrap;
  .list-complete-item {
    transition: all 0s 0.1s linear;
    display: inline-block;
    margin-right: 10px;
  }
  .list-complete-enter,
  .list-complete-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }
  .subjectAddButBox {
    cursor: pointer;
    width: 350px;
    height: 350px;
    margin: 10px;
    background-color: #e3e9f1;
    text-align: center;
    p {
      font-size: 20px;
      font-weight: bolder;
      color: #bfbfbf;
      text-align: center;
    }
    i {
      color: #bfbfbf;
      font-size: 160px;
      font-weight: bolder;
      line-height: 130%;
      margin-top: 40px;
    }
  }
}
</style>
